import type { FeatureEstimate, SensitivityScenario, ModelPricing } from "./schemas.js";

export function generateSensitivity(
  estimates: FeatureEstimate[],
  models: ModelPricing[],
): SensitivityScenario[] {
  const totalTokens = estimates.reduce((sum, e) => sum + e.withOverhead.total, 0);
  const totalCost = estimates.reduce((sum, e) => sum + e.estimatedCost, 0);

  // All-frontier: recalculate with Opus pricing
  const frontier = models.find((m) => m.tier === "frontier");
  let allFrontierCost = totalCost;
  if (frontier) {
    const totalInput = estimates.reduce((sum, e) => sum + e.withOverhead.input, 0);
    const totalOutput = estimates.reduce((sum, e) => sum + e.withOverhead.output, 0);
    allFrontierCost =
      Math.round(
        ((totalInput / 1_000_000) * frontier.input_per_mtok +
          (totalOutput / 1_000_000) * frontier.output_per_mtok) *
          100,
      ) / 100;
  }

  return [
    {
      name: "Optimistic",
      adjustment: -0.25,
      totalTokens: Math.round(totalTokens * 0.75),
      totalCost: Math.round(totalCost * 0.75 * 100) / 100,
    },
    {
      name: "Expected",
      adjustment: 0,
      totalTokens,
      totalCost,
    },
    {
      name: "Pessimistic",
      adjustment: 0.5,
      totalTokens: Math.round(totalTokens * 1.5),
      totalCost: Math.round(totalCost * 1.5 * 100) / 100,
    },
    {
      name: "All-Frontier (Opus)",
      adjustment: 0,
      totalTokens,
      totalCost: allFrontierCost,
    },
  ];
}
